import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { Plan } from './Plan';

export const PlanPage = () => {
  useTitle('Карточка плана');

  return (
    <Layout withFooter>
      <Plan />
    </Layout>
  );
};
